import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
const UserManagementPage = () => (<Box sx={{ p: 3 }}><Card><CardContent><Typography variant="h4">User Management</Typography><Typography>Coming soon</Typography></CardContent></Card></Box>);
export default UserManagementPage;